var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"instructions"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.instructions)}}),_c('div',{staticClass:"btn-v"},[_c('button',[_c('a',{attrs:{"href":_vm.fileUrl,"target":"_blank"}},[_vm._v("下载期刊投稿模板")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }